/**
 * Keep only fields needed to create a shop order.
 * Full Redux userAcc often embeds currentCart / personalSales / macroPersonal
 * and can push Order.create over Mongo's 16MB limit on large carts.
 */
export function slimCreateOrderUserAcc(userAcc = {}, overrides = {}) {
  const src = userAcc && typeof userAcc === 'object' ? userAcc : {}
  const next = {
    name: overrides.name != null ? overrides.name : src.name || '',
    phone: overrides.phone != null ? overrides.phone : src.phone || '',
    tradeName:
      overrides.tradeName != null ? overrides.tradeName : src.tradeName || '',
  }
  if (src.email) next.email = src.email
  if (src._id || src.id) next._id = src._id || src.id
  if (src.platform) next.platform = src.platform
  return next
}

const ITEM_DROP_KEYS = new Set([
  'personalSales',
  'macroPersonal',
  'currentCart',
  'suppSites',
  'selectedMatchesLast',
])

const EXCEL_ERROR_RE = /^#(REF|N\/A|VALUE|DIV\/0|NAME|NULL|NUM|CALC)!?$/i

const ITEM_NUMBER_KEYS = new Set([
  'quantity',
  'quantityOrder',
  'marketPrice',
  'marketPriceDP',
  'marketPriceSDP',
  'marketPriceCP',
  'ourPrice',
  'ourPriceDP',
  'ourPriceSDP',
  'ourPriceCP',
  'IVA',
  'IVADP',
  'IVASDP',
  'IVACP',
  'spoPrice',
  'SPOPrice',
  'minQt',
])

function coerceNumberOrNull(value) {
  if (value == null || value === '') return null
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed || EXCEL_ERROR_RE.test(trimmed)) return null
    const n = Number(trimmed.replace(/\s/g, '').replace(',', '.'))
    return Number.isFinite(n) ? n : null
  }
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

export function slimCreateOrderItems(items = []) {
  return (Array.isArray(items) ? items : []).map((item) => {
    if (!item || typeof item !== 'object') return item
    const next = {}
    for (const [key, value] of Object.entries(item)) {
      if (ITEM_DROP_KEYS.has(key)) continue
      next[key] = ITEM_NUMBER_KEYS.has(key) ? coerceNumberOrNull(value) : value
    }
    return next
  })
}
